import { render } from "./GrupoSocioNegocioForm.vue?vue&type=template&id=a4f58d46&scoped=true"
import script from "./GrupoSocioNegocioForm.vue?vue&type=script&lang=js"
export * from "./GrupoSocioNegocioForm.vue?vue&type=script&lang=js"

import "./GrupoSocioNegocioForm.vue?vue&type=style&index=0&id=a4f58d46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f58d46"]])

export default __exports__